import React from "react";
import { presetSizes } from "./constants";
import { BaseSpinner, BaseSpinnerCircle, BaseSpinnerSvg } from "./styled";
import { jsx as _jsx } from "react/jsx-runtime";
var Spinner = /*#__PURE__*/React.forwardRef(function (_ref, forwardedRef) {
  var _ref$delay = _ref.delay,
    delay = _ref$delay === void 0 ? 0 : _ref$delay,
    _ref$size = _ref.size,
    providedSize = _ref$size === void 0 ? "md" : _ref$size,
    onBackgroundColor = _ref.onBackgroundColor;
  var size = presetSizes[providedSize];
  var animationDelay = "".concat(delay, "ms");
  return /*#__PURE__*/_jsx(BaseSpinner, {
    style: {
      animationDelay: animationDelay,
      width: size,
      height: size
    },
    children: /*#__PURE__*/_jsx(BaseSpinnerSvg, {
      height: size,
      width: size,
      viewBox: "0 0 16 16",
      xmlns: "http://www.w3.org/2000/svg",
      ref: forwardedRef,
      style: {
        animationDelay: animationDelay
      },
      children: /*#__PURE__*/_jsx(BaseSpinnerCircle, {
        cx: "8",
        cy: "8",
        r: "7",
        color: onBackgroundColor
      })
    })
  });
});
Spinner.displayName = "Spinner";
export default Spinner;